import { render, staticRenderFns } from "./qxOne.vue?vue&type=template&id=a2c97fa8"
import script from "./qxOne.vue?vue&type=script&lang=js"
export * from "./qxOne.vue?vue&type=script&lang=js"
import style0 from "./qxOne.vue?vue&type=style&index=0&id=a2c97fa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports